/* eslint-disable no-console */
import { Environment } from '../enums/Environment';

export class Logger {
  private environment: Environment;

  public get debugMode(): boolean {
    return [Environment.LOCAL, Environment.DEV, Environment.TEST].includes(this.environment);
  }

  public get env(): Environment {
    return this.environment;
  }

  constructor(environment: Environment) {
    this.setEnvironment(environment);
  }

  public setEnvironment(debugMode: Environment): void {
    this.environment = Environment[debugMode];
  }

  public log(message: string, ...optionalParams: unknown[]): void {
    if (this.debugMode) {
      console.log(message, ...optionalParams);
    }
  }

  public warn(message: string, ...optionalParams: unknown[]): void {
    if (this.debugMode) {
      console.warn(message, ...optionalParams);
    }
  }

  public error(message: string, ...optionalParams: unknown[]): Error {
    if (this.debugMode) {
      console.error(message, ...optionalParams);
    }
    return new Error(`${message} | ${optionalParams && JSON.stringify(optionalParams)}`);
  }
}
